import { useExtension } from '@healthblocks-io/core'

import { ADMIN_MESSAGE_EXTENSION_TYPE } from '../types/admin-message.type'

import type { Extension } from '@healthblocks-io/core'
import type { AdminMessage } from '../types/admin-message.type'

/**
 * Fetches the admin message extension from healthblocks
 * @returns AdminMessage if available, along with SWR loading state
 */
export const useAdminMessage = (swrConfig?: {
  refreshInterval?: number
}): {
  adminMessage: AdminMessage | undefined
  isLoading: boolean
  error: unknown
} => {
  const adminMessageExtensions = useExtension(
    {
      context: 'project',
      type: ADMIN_MESSAGE_EXTENSION_TYPE,
    },
    swrConfig,
  )

  const adminMessageExtension = adminMessageExtensions?.data?.[0] as Extension<AdminMessage> | undefined

  return {
    adminMessage: adminMessageExtension?.options,
    isLoading: adminMessageExtensions.isLoading,
    error: adminMessageExtensions.error,
  }
}
